<template>
  <div id="venue">
    <div id="overlay" v-show="isProcessing">
      <div id="textOverlay">
        {{ strings.processingorder
        }}<pulse-loader :color="'white'"></pulse-loader>
      </div>
    </div>
    <MPHeader
      v-if="printHeader == 1 && !isHorizontalForm"
      v-collision="['groupone']"
      @collide="onCollideHandler"
      @non-collide="nonCollideHandler"
    />
    <MPHeader
      v-if="printHeader == 1 && isHorizontalForm"
    />
    <div class="row no-margin">
      <div
        class="sidebar no-margin"
        v-if="isLoggedIn"
        :class="{ 'col-lg-2': sidebarState, 'no-sidebar': sidebarOffState }"
      >
        <MPSidebar />
      </div>
      <div
        class="sidebar no-margin sidebar__log-out"
        v-else
        :class="{ 'col-lg-2': sidebarState, 'no-sidebar': sidebarOffState }"
      >
        <MPSidebarOut />
      </div>
      <div
        class="main-content no-margin"
        :class="{ 'col-lg-10': sidebarState, 'col-md-12': sidebarOffState }"
      >
        <!-- Covid Notification Banner -->
        <Banner />
        <!-- Promotional Banner -->
        <PromotionalBanner />

        <!-- <div class="sectionWithBackground"> -->
          <MPHero v-collision="['groupone']" v-if="!showCheckOutPage" />
        <!-- </div> -->

        <MPContainer v-if="!showCheckOutPage" />
        <OperaCheckout v-if="showCheckOutPage && isOpera" />
        <RegusCheckout v-if="showCheckOutPage && isRegus" />
      </div>
    </div>
    <MPFooter
      v-if="printFooter == 1"
      v-collision="['footer']"
      @collide="footerCollided"
      @non-collide="footerUnCollided"
    />
    <MPWLFooter
      v-if="printFooter != 1 && !isHorizontalForm"
      v-collision="['footer']"
      @collide="footerCollided"
      @non-collide="footerUnCollided"
    />
      <MPWLFooter
      v-if="printFooter != 1 && isHorizontalForm"
    />
    <MPRequestBooking />
  </div>
</template>

<script>
import MPHeader from './components/Header.vue'
import MPFooter from './components/Footer.vue'
import MPWLFooter from './components/MPWLFooter.vue'
import MPHero from './components/Hero.vue'
import MPContainer from './components/Container.vue'
import MPSidebar from './components/Sidebar.vue'
import MPSidebarOut from './components/Sidebarout.vue'
import MPRequestBooking from './components/RequestBooking.vue'
import './scss/main.scss'
import 'vue2-timepicker/dist/VueTimepicker.css'
import moment from 'moment'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import OperaCheckout from './components/OperaCheckout.vue'
import RegusCheckout from './components/RegusCheckout.vue'
import Banner from './components/covidCapacity/Banner.vue';
import PromotionalBanner from './components/promotionalBanner/PromotionalBanner.vue';
import * as dataLayer from './assets/misc/dataLayer.js';

let venue_id = window.venue_id ? JSON.parse(window.venue_id) : ''
let regus_centre_id = window.regus_id ? JSON.parse(window.regus_id) : ''
let logoUrl = window.logoUrl
let isBE = window.isBE == '1' ? true : false
let useNewVenuePage = window.useNewVenuePage
let useNewCheckoutPage = window.useNewCheckoutPage == '1' ? true : false
let isNCH = window.isNCH == '1' ? true : false
let _isOpera = window.isOpera == '1' ? true : false
let disable_enddate_picker = window.mp_disable_enddate_picker === '1' ? true : false
let _defaultTab = window.default_tab
let _defaultHour = window.default_hour
let _defaultDelegates = window.default_delegates
let _defaultMeetingLength = window.default_meeting_length
let _defaultDow = parseInt(window.default_dow)
var printFooter = 1
var printHeader = 1

if (document.getElementById('footer')) {
  printFooter = 0
}
if (document.getElementById('wl-header')) {
  printHeader = 0
}

export default {
  name: 'venue',
  data() {
    return {
      isLoggedIn: '',
      openSidebar: this.$store.state.sidebarState,
      printFooter: printFooter,
      printHeader: printHeader
    }
  },
  components: {
    MPHeader,
    MPHero,
    MPContainer,
    MPFooter,
    MPSidebar,
    MPSidebarOut,
    PulseLoader,
    MPRequestBooking,
    OperaCheckout,
    RegusCheckout,
    MPWLFooter,
    Banner,
    PromotionalBanner
  },
  computed: {
    isHorizontalForm() {
      return this.$store.state.isBE && !this.$store.state.isRegus
    },
    showCheckOutPage() {
      return this.$store.state.showCheckOutPage
    },
    sidebarState() {
      return this.$store.state.sidebarState
    },
    sidebarOffState() {
      return !this.$store.state.sidebarState
    },
    userInfo() {
      return this.$store.state.setUserInfo
    },
    isProcessing() {
      return this.$store.state.isProcessing
    },
    strings() {
      return this.$store.state.strings
    },
    isOpera() {
      return this.$store.state.isOpera
    },
    isRegus() {
      return this.$store.state.isRegus
    },
    isFK_WL() {
      return window.location.hostname === "forsakringskassan.cwteasymeetings.com" 
    }
  },
  methods: {
    onCollideHandler(collider) {
      this.$store.commit('showLogo', false)
    },
    nonCollideHandler(collider) {
      this.$store.commit('showLogo', true)
    },
    footerCollided(collider) {
      this.$store.commit('setFooter', true)
    },
    footerUnCollided(collider) {
      this.$store.commit('setFooter', false)
    },
    pushEEC(){
     let category = this.$store.state.currentTab == "room" ? "room": "package";
     let impressions = [{
      id: venue_id,
      name: this.$store.state.venueInfo.title,
      brand: this.$store.state.venueInfo.title + " - " + venue_id,
      category: category,
      list:'venue', //no changes
      position: 1, //no changes
      dimension3: this.$store.state.venueInfo.city,  //addThis is the city
      dimension4: this.$store.state.venueInfo.country_code ,     //addThis is the country
      dimension5: this.$store.state.venueInfo.venue_type_en,  //addThis is the venue type 	
     }]
      dataLayer.pushImpressionView(impressions);
    },
    dynamicURLParamSetup() {
      let route = this.$route

      try {
        const dynamic_url_param_settings = JSON.parse(window.dynamic_url_param_settings)

        const startDateKey = dynamic_url_param_settings.startDate?.paramKey
        const endDateKey = dynamic_url_param_settings.endDate?.paramKey
        const durationKey = dynamic_url_param_settings.duration?.paramKey
        const delegatesKey = dynamic_url_param_settings.delegates?.paramKey
        const discountCodeKey = dynamic_url_param_settings.discountCode?.paramKey

        if (route.query[startDateKey] && route.query[endDateKey]) {
          let dt, edt, startTime, endTime, meetingLength

          if (dynamic_url_param_settings.unixFormat) {
            dt = moment.unix(route.query[startDateKey])
            edt = moment.unix(route.query[endDateKey])
          } else {
            if (route.query[durationKey]) {
              const durationType = dynamic_url_param_settings.duration.durationTypes.find(type => type.key === route.query[durationKey])

              startTime = durationType.startTime
              endTime = durationType.endTime
            } else {
              startTime = '09:00'
              endTime = '17:00'
            }

            const startTimeComponents = startTime.split(':')
            const endTimeComponents = endTime.split(':')

            if (parseInt(endTimeComponents[1]) - parseInt(startTimeComponents[1]) === 0) {
              meetingLength = parseInt(endTimeComponents[0]) - parseInt(startTimeComponents[0])
            } else {
              meetingLength = parseInt(endTimeComponents[0]) - parseInt(startTimeComponents[0]) + 1
            }

            dt = moment(`${route.query[startDateKey]} ${startTime}`, `${dynamic_url_param_settings.startDate.format} HH:mm`)
            edt = moment(`${route.query[endDateKey]} ${endTime}`, `${dynamic_url_param_settings.endDate.format} HH:mm`)
          }

          if (moment().diff(dt, 'days') > 0 || !dt.isValid()) { //If params date is in the past then set it to today
            return false
          } else {
            this.$store.commit('setDateTime', dt.format('DD-MM-YYYY HH:mm'))
            this.$store.commit('setDate', dt.format('DD-MM-YYYY'))
            this.$store.commit('setTime', dt.format('HH:mm'))
            this.$store.commit('setEndDateTime', edt.format('DD-MM-YYYY HH:mm'))
            this.$store.commit('setEndDate', edt.format('DD-MM-YYYY'))
            this.$store.commit('setEndTime', edt.format('HH:mm'))

            if (!dynamic_url_param_settings.unixFormat) {
              this.$store.commit('setMeetingLength', meetingLength)
            }
          }
        } else {
          return false
        }

        if (route.query[delegatesKey]) {
          this.$store.commit('setDelegates', route.query[delegatesKey])
        } else {
          this.$store.commit('setDelegates', 8)
        }

        if (route.query[discountCodeKey]) {
          this.$cookie.set('discount_code', route.query[discountCodeKey], 100)
          this.$store.commit('setDiscountCode', route.query[discountCodeKey])
        }

        return true
      } catch (e) {
        console.log("setup failed with catch")
        console.log(e)
        return false
      }
    }
  },
  mounted() {
    this.$cookie.set('venue_redirect_url', window.location.href, 100)
    if(venue_id){
      this.$cookie.set('venue_id', venue_id, 100)
    }
    let language_array = [
      'en',
      'en-us',
      'da',
      'fi',
      'fr',
      'de',
      'it',
      'lv',
      'ru',
      'es',
      'sv',
      'zh',
      'tr',
      'cs',
      'nb',
      'et',
      'nl',
      'nl-nl',
      'hu-hu',
      'de-de',
      'pl',
      'sk',
      'sl',
      'sv-se',
      'hu',
      'is'
    ]
    let path = this.$route.path.substring(1)
    let array_path = path.split('/')
    let lang = ''
    let alias = ''
    let meeting_length = ''
    let delegates = ''
    let datetime = ''
    let route = this.$route
    let siteUrl = window.location.hostname

    if (route.query.discount_code) {
      this.$cookie.set('discount_code', route.query.discount_code, 100)
      this.$store.commit('setDiscountCode', route.query.discount_code)
    } else {
      if (this.$cookie.get('discount_code')) {
        this.$store.commit('setDiscountCode', this.$cookie.get('discount_code'))
      }
    }

    // Always add AVROPA discount code for FK wl
    if (this.isFK_WL) {
      this.$cookie.set('discount_code', "AVROPA", 100)
      this.$store.commit('setDiscountCode', "AVROPA")
    }

    if (isBE) {
      this.$store.commit('setBE', true)
    }

    if (isBE && useNewVenuePage) { // Use New Room + Package venue page check
      this.$store.commit('setUseNewVenuePage', true)
    }

    if (useNewCheckoutPage) {
      this.$store.commit('setUseNewCheckoutPage', true)
    }

    if (isNCH) {
      this.$store.commit('setNCH', true)
    }

    if (window.location.host == 'sjp.cwteasymeetings.com' || window.location.host == 'interikea.cwteasymeetings.com') {
      this.$store.commit('setSJP', true)
    }

    if (_isOpera) {
      this.$store.commit('setOperaVenue', true)
    }

    if (disable_enddate_picker) {
      this.$store.commit('setIsEndDateDisabled', disable_enddate_picker)
    }

    if (siteUrl == 'hansel.meetingpackage.com') {
      this.$store.commit('setHanselWL', true)
    }

    this.$store.dispatch('checkUser').then(() => {
      if (this.$store.state.userInfo == false) {
        this.isLoggedIn = false
      } else {
        this.isLoggedIn = true
      }
    })

    let tab = ''
    if (_defaultTab) {
      tab = _defaultTab
    } else if (route.query.type) {
      if (route.query.type == 'package') {
        tab = 'package'
      } else {
        tab = 'room'
      }
    } else if (this.$cookie.get('_pref_index')) {
      if (this.$cookie.get('_pref_index') == 'package_index') {
        tab = 'package'
      } else {
        tab = 'room'
      }
    } else {
      // #hack for Hotel Katajanokka and Holiday Inn
      if (parseInt(venue_id) == 25668 || parseInt(venue_id) == 98539) {
        tab = 'room'
      } else {
        tab = 'package'
      }
    }

    if (isBE && useNewVenuePage) {
      this.$store.commit('setCurrentTab', 'room')
    } else {
      this.$store.commit('setCurrentTab', tab)
    }

    if (language_array.includes(array_path[0])) {
      lang = array_path[0];
      if(lang == 'sv-se'){
        lang = 'sv';
      }
      if(lang == 'nl-nl'){
        lang = 'nl';
      }
      if(lang == 'de-de'){
        lang = 'de';
      }
      if(lang == 'hu-hu'){
        lang = 'hu';
      }
      if(lang == 'en-us' && window.is_radisson()){
        lang = 'en';
      }
      for (let i = 1; i < array_path.length; i++) {
        alias += '/' + array_path[i]
      }
      alias = alias.substring(1)
    } else {
      lang = 'en'
      alias = path
    }

    let result = false
    result = this.dynamicURLParamSetup()

    if (result === false) {
      // Meeting Length
      if (tab == 'package' && _isOpera && !useNewVenuePage) {
        this.$store.commit('setMeetingLength', 'oneday')
      } else if (route.query['meeting-length']) {
        let meeting_length = route.query['meeting-length']
        if (meeting_length == 'Overnight') {
          meeting_length = 'overnight'
        } else if (meeting_length == 'Two-Days') {
          meeting_length = 'twodays'
  
          if (this.isOpera) {
            this.$store.commit('setShowOperaError', true)
            meeting_length = 8
          }
        } else if (meeting_length == 'morethan1' && this.isOpera) {
          this.$store.commit('setShowOperaError', true)
          meeting_length = 2
        }
        this.$store.commit('setMeetingLength', meeting_length)
      } else if (this.$cookie.get('_pref_mt')) {
        let meeting_length = this.$cookie.get('_pref_mt')
        if (meeting_length == 'Overnight') {
          meeting_length = 'overnight'
        } else if (meeting_length == 'Two Days' || meeting_length == 'Two+Days') {
          meeting_length = 'twodays'
        } else if (meeting_length == 'overone') {
          meeting_length = 8
        }
        this.$store.commit('setMeetingLength', meeting_length)
      } else {
        meeting_length = 8
        if(_defaultMeetingLength){
          meeting_length = _defaultMeetingLength
        }
  
        this.$store.commit('setMeetingLength', meeting_length)
      }
  
      if (route.query.delegates) {
        this.$store.commit('setDelegates', route.query.delegates)
      } else if (
        this.$cookie.get('_pref_qty') &&
        this.$cookie.get('_pref_qty') != 'undefined'
      ) {
        this.$store.commit('setDelegates', this.$cookie.get('_pref_qty'))
      } else if (isNCH) {
        this.$store.commit('setDelegates', 8)
      } else {
        let del_count = 10;
        if (window.wl_default_delegates) {
          del_count = window.wl_default_delegates;
        }
        if (_defaultDelegates) {
          del_count = _defaultDelegates;
        }
        this.$store.commit('setDelegates', del_count)
      }
  
      let datetime_cookie_name = lang + '_pref_dt'
      datetime = this.$cookie.get(datetime_cookie_name)
      let isEndDateInitalized = false
      if (route.query.datetime) {
        let dt = moment.unix(route.query.datetime)
        let edt
  
        if (moment().diff(dt, 'days') > 0 || !dt.isValid()) { //If params date is in the past then set it to today
          dt = moment().add(1, 'weeks').isoWeekday(1).hour(9).minute(0)
          edt = moment().add(1, 'weeks').isoWeekday(1).hour(17).minute(0)
          this.$store.commit('setDateTime', dt.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setDate', dt.format('DD-MM-YYYY'))
          this.$store.commit('setTime', '09:00')
          this.$store.commit('setEndDateTime', edt.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', edt.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', '17:00')
          isEndDateInitalized = true
        } else {
          this.$store.commit('setDateTime', dt.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setDate', dt.format('DD-MM-YYYY'))
          this.$store.commit('setTime', dt.format('HH:mm'))
        }
        if (route.query['meeting-length'] && !isEndDateInitalized) {
          edt = moment.unix(route.query.datetime).add(route.query['meeting-length'], 'hours')
          this.$store.commit('setEndDateTime', edt.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', edt.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', edt.format('HH:mm'))
          isEndDateInitalized = true
        }
      } else if (datetime) {
        // Decode datetime cookie
        datetime = decodeURIComponent((datetime + '').replace(/\+/g, '%20'))
        datetime = moment(datetime, 'D MMMM, YYYY @ HH:mm')
        
        if (moment().diff(datetime, 'days') > 0) { //If cookie date is in the past then set it to today
          datetime = moment().add(1, 'weeks').isoWeekday(1).hour(9).minute(0)
          let endDatetime = moment().add(1, 'weeks').isoWeekday(1).hour(17).minute(0)
          this.$store.commit('setDateTime', datetime.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setDate', datetime.format('DD-MM-YYYY'))
          this.$store.commit('setTime', '09:00')
          this.$store.commit('setEndDateTime', endDatetime.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', endDatetime.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', '17:00')
          isEndDateInitalized = true
        }
        this.$store.commit('setDateTime', datetime.format('DD-MM-YYYY HH:mm'))
        this.$store.commit('setDate', datetime.format('DD-MM-YYYY'))
        this.$store.commit('setTime', datetime.format('HH:mm'))
      } else {
        // Default date to next monday 9AM when no cookie or url date is set
        let defaultDate = moment().add(1, 'weeks').isoWeekday(1).hour(9).minute(0)
        let defaultTime = '09:00'
        if(_defaultHour){
          defaultTime = _defaultHour
        }
        
        this.$store.commit(
          'setDateTime',
          defaultDate.format('DD-MM-YYYY') + defaultTime
        )
        this.$store.commit('setDate', defaultDate.format('DD-MM-YYYY'))
        this.$store.commit('setTime', defaultTime)
        this.$store.commit('setEndDateTime', `${defaultDate.format('DD-MM-YYYY')} 17:00`)
        this.$store.commit('setEndDate', defaultDate.format('DD-MM-YYYY'))
        this.$store.commit('setEndTime', "17:00")
        isEndDateInitalized = true
      }
      // End date
      let endDatetime_cookie_name = lang + '_pref_edt'
      let endDatetime = this.$cookie.get(endDatetime_cookie_name)
      if (!isEndDateInitalized) {
        if (route.query['end-datetime']) {
          let edt = moment.unix(route.query['end-datetime'])
          this.$store.commit('setEndDateTime', edt.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', edt.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', edt.format('HH:mm'))
        } else if (endDatetime) {
          // Decode datetime cookie
          endDatetime = decodeURIComponent((endDatetime + '').replace(/\+/g, '%20'))
          endDatetime = moment(endDatetime, 'D MMMM, YYYY @ HH:mm')
          if (moment().diff(endDatetime, 'days') > 0) { //If cookie end date is in the past then set it to today
            endDatetime = moment().add(1, 'weeks').isoWeekday(1).hour(17).minute(0)
          }
          this.$store.commit('setEndDateTime', endDatetime.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', endDatetime.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', endDatetime.format('HH:mm'))
        }
        else {
          endDatetime = moment().add(1, 'weeks').isoWeekday(1).hour(17).minute(0)
          this.$store.commit('setEndDateTime', endDatetime.format('DD-MM-YYYY HH:mm'))
          this.$store.commit('setEndDate', endDatetime.format('DD-MM-YYYY'))
          this.$store.commit('setEndTime', '17:00')
        }
      }
    }

    this.$store.dispatch('changeLanguage', {
      lang: lang,
      alias: decodeURI(alias)
    })

    if (isBE && useNewVenuePage) {
      this.$store
      .dispatch('getNewVenue', {
        lang: lang,
        alias: decodeURI(alias),
        venueID: venue_id
      }).then(() => {
         this.pushEEC();
    });

      // this.$store.dispatch('fetchPackageAndRoom', {venueID: venue_id})
    } else {
      this.$store
      .dispatch('getVenue', {
        lang: lang,
        alias: decodeURI(alias),
        venueID: venue_id
      }).then(() => {
         this.pushEEC();
    });
    }

    // If venue is Regus, include this information to state.
    if (regus_centre_id != '') {
      this.$store.commit('setRegusVenue')
    }
  }
}
</script>

<style scope>
.sectionWithBackground {
  display: flex;
  justify-content: center;
  margin: 20px 0 20px 0;
}
.sidebar {
  transition: all 0.3s ease-in;
}
.no-sidebar {
  display: none;
}
#overlay {
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 500000;
  cursor: not-allowed;
}
#textOverlay {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.v-spinner {
  float: right;
}
.loading-indicator .v-spinner {
  position: absolute;
  left: calc((100% - 57px) / 2);
  margin-top: 50px;
  width: 57px;
}
.loading-indicator {
  min-height: 110px;
}
#dayTabList .fade {
  opacity: 1 !important;
}
</style>
